/**
 * Copyright 2022-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { When } from "react-if";
import { useHistory } from "react-router-dom";
import { Button } from "@nordcloud/gnui";
import { useDisclosure } from "~/hooks";
import { ROUTES } from "~/routing/routes";
import { DeleteNotificationGroup } from "./DeleteNotificationGroup/DeleteNotificationGroup";

type Props = {
  notificationGroupId: string;
  notificationGroupName: string;
  onSuccess?: () => void;
};

export function Action({ notificationGroupId, notificationGroupName }: Props) {
  const {
    isOpen: isDeleteModalOpen,
    close: closeDeleteModal,
    open: openDeleteModal,
  } = useDisclosure(false);

  const history = useHistory();

  const onSuccess = () => history.push(ROUTES.notificationGroups.index);

  return (
    <>
      <Button
        size="md"
        severity="low"
        aria-label="delete notification group"
        icon="trash"
        onClick={openDeleteModal}
      />
      <When condition={isDeleteModalOpen}>
        <DeleteNotificationGroup
          {...{
            notificationGroupId: notificationGroupId,
            notificationGroupName: notificationGroupName,
            isDeleteModalOpen: isDeleteModalOpen,
            onSuccess,
          }}
          close={closeDeleteModal}
        />
      </When>
    </>
  );
}
